import React from 'react'

import BondsListItem from './BondsListItem'
import { SelectBond, ViewBondDetails } from '../actions/bondActions'
import { BondConfigItem } from '@bdswiss/mt4-connector'
import { notifyParentSignupRequired } from '../utils/common-utils'

export interface Props {
  bonds: BondConfigItem[]
  demo?: string
  onSelectBond: (bond: BondConfigItem) => SelectBond
  onViewBondDetails: (bond: BondConfigItem) => ViewBondDetails
}

class BondsList extends React.Component<Props> {
  public render() {
    const { bonds, demo } = this.props
    return (
      <div className="d-flex show no-scrolling">
        <div className="bonds-wrapper d-flex flex-wrap justify-content-around no-scrolling">
          {bonds.map(bond => (
            <BondsListItem
              bond={bond}
              key={bond.isin}
              onSelectBond={() =>
                demo ? notifyParentSignupRequired() : this.props.onSelectBond(bond)
              }
              onViewBondDetails={() => this.props.onViewBondDetails(bond)}
            />
          ))}
        </div>
      </div>
    )
  }
}

export default BondsList
